import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { PreviewInfo } from '../../types';

interface InfoTabProps {
  info: PreviewInfo;
  onChange: (info: PreviewInfo) => void;
  disabled?: boolean;
}

export function InfoTab({ info, onChange, disabled = false }: InfoTabProps) {
  const { t } = useTranslation('customer-onboarding');

  const handleChange = (field: keyof PreviewInfo, value: string) => {
    onChange({ ...info, [field]: value });
  };

  const handleAddressChange = (
    field: keyof PreviewInfo['shippingAddress'],
    value: string
  ) => {
    onChange({
      ...info,
      shippingAddress: { ...info.shippingAddress, [field]: value },
    });
  };

  return (
    <div className="space-y-6">
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="organisationName">{t('info.organisationName')}</Label>
          <Input
            id="organisationName"
            value={info.organisationName}
            onChange={(e) => handleChange('organisationName', e.target.value)}
            disabled={disabled}
            placeholder={t('info.organisationName')}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="quoteNumber">{t('info.quoteNumber')}</Label>
          <Input
            id="quoteNumber"
            value={info.quoteNumber}
            onChange={(e) => handleChange('quoteNumber', e.target.value)}
            disabled={disabled}
            placeholder={t('info.quoteNumberPlaceholder')}
          />
        </div>
      </div>

      <div className="space-y-4">
        <h4 className="font-medium">{t('info.shippingAddress')}</h4>
        <div className="grid gap-4 sm:grid-cols-3">
          <div className="space-y-2 sm:col-span-3">
            <Label htmlFor="street">{t('info.street')}</Label>
            <Input
              id="street"
              value={info.shippingAddress.street}
              onChange={(e) => handleAddressChange('street', e.target.value)}
              disabled={disabled}
              placeholder={t('info.streetPlaceholder')}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="city">{t('info.city')}</Label>
            <Input
              id="city"
              value={info.shippingAddress.city}
              onChange={(e) => handleAddressChange('city', e.target.value)}
              disabled={disabled}
              placeholder={t('info.cityPlaceholder')}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="country">{t('info.country')}</Label>
            <Input
              id="country"
              value={info.shippingAddress.country}
              onChange={(e) => handleAddressChange('country', e.target.value)}
              disabled={disabled}
              placeholder={t('info.countryPlaceholder')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
